import React, { Component } from "react";
import "./Footer.css";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <div className="footer" style={{ height: "50px" }}>
          <p className="footer-text"> Organize Mate © 2018 </p>
          <span className="footer-icon">
            <a href="mailto:contact.organizemate@gmail.com">
              <img
                src={require("../../images/black-envelope.png")}
                style={{ height: "17px" }}
                alt="envelope-icon"
              />
            </a>
            <a
              href="https://www.facebook.com/OrganizeMate/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require("../../images/facebook-logo.png")}
                style={{ height: "17px", marginLeft: "30px" }}
                alt="facebook-icon"
              />
            </a>
            <img
              src={require("../../images/twitter.png")}
              style={{ height: "17px", marginLeft: "30px" }}
              alt="twitter-icon"
            />
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js